import { ToastContainer, toast } from "react-toastify";
import React from "react";
import "react-toastify/dist/ReactToastify.css";
const isAuctionEnded = (auction) => {
  if (!auction.started || auction.ended) return true; // If auction is marked as ended, return true

  const currentTime = Date.now(); // Get current timestamp in milliseconds
  const endTime = auction.startedTime + auction.duration * 1000; // Convert duration to milliseconds

  return currentTime >= endTime;
};
const imagePath = (image) =>
  process.env.REACT_APP_API_BASE_URL + "/"+ image;
const notifySuccess = (message) =>
  toast.success(message, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

const notifyError = (message) =>
  toast.error(message, {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });

// eslint-disable-next-line no-unused-expressions
<ToastContainer
  position="top-center"
  autoClose={3000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  rtl={false}
  pauseOnFocusLoss
  draggable
  pauseOnHover
/>;

export {
  ToastContainer,
  notifySuccess,
  notifyError,
  imagePath,
  isAuctionEnded,
};
